import Vue from "vue";
import { getRoleAuth0 } from '@/plugins/role';
const vm = new Vue();

export const storageCache = {
    get: function (key) {
        let user = localStorage.getItem(key);
        if (user) {
            user = JSON.parse(user);
        }
        return user;
    },
    set: function (key, user) {
        if (user) {
            if (user.body) {
                localStorage.setItem('access_token', user.body.access_token);
            }
            if (user.decodedToken) {
                const { email, name, exp, sub, iat, tel } = user.decodedToken.claims;
                let userFakeAuth0 = {
                    "iss": "pop.shippop.com", 
                    "sub": sub, 
                    "name": name, 
                    "email": email?(email.split('@')[0]+'+auth0'+email.split('@')[1]):'', 
                    "tel": tel,
                    "role": "shippop", 
                    "role_auth0": user.decodedToken.claims[process.env.VUE_APP_AUTH0_NAMESPACE],
                    "setting": [], 
                    "shop_package": "-", 
                    "shop_code": "-", 
                    "dealer_id": 0, 
                    "master_id": "-", 
                    "under_by": "-", 
                    "shop_name": "-", 
                    "payment_type": "-", 
                    "iat": iat, 
                    "exp": exp,
                    "provider": "auth0",
                }
                let userFakeWalletAuth0 = {
                    "status": null,
                    "error": null,
                    "available_balance": 0,
                    "peg_balance": 0,
                    "balance": 0
                }
                localStorage.setItem('user', JSON.stringify(userFakeAuth0));
                localStorage.setItem('wallet', JSON.stringify(userFakeWalletAuth0));
            }
        }
        localStorage.setItem(key, JSON.stringify(user));
    },
    remove: function (key) {
        localStorage.removeItem(key);
    },
    allKeys: function () {
        return Object.keys(localStorage);
    }
}

export const checkRolesAuth0 = (roles = []) => {
    let status = true
    if( vm.$USER_LOGIN.get().isShippop && vm.$USER_LOGIN.get().details.provider){
        status = roles.some((r) => vm.$USER_LOGIN.get().details.role_auth0.includes(r))
    }
    return status;
}

export const auth0RoleMenuLayout = (page = '') => {
    let status = true;

    switch ( String(page) ) {
        case 'tracking': //ติดตามสถานะพัสดุ
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'transports': //จัดการขนส่ง
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'usersmanage': //จัดการสมาชิก(SHIPPOP)
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_ENGINEER,
            ])
            break;
        case 'agentmanage': //จัดการตัวแทนจำหน่าย(SuperAdmin)
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'brancemanage': //จัดการร้านค้า (ทุกสาขา)
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'fakecustomer': //จัดการลูกค้าหน้าสาขา
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'usershop': //จัดการสมาชิก(POP SHIPPOP)
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'waiveinvoice': //ยกเว้นค่าขนส่งในใบแจ้งหนี้
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_CUSTOMER_SERVICE,
                vm.$ROLE.SHIPPOP_MARKETING
            ])
            break;
        case 'wallet':
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_ENGINEER,
                vm.$ROLE.SHIPPOP_CUSTOMER_SERVICE,
                vm.$ROLE.SHIPPOP_MARKETING,
                vm.$ROLE.SHIPPOP_SALES,
                vm.$ROLE.SHIPPOP_ACCOUNTING,
                vm.$ROLE.SHIPPOP_JUNIOR,
                vm.$ROLE.SHIPPOP_INTERN
            ])
            break;
        case 'accounting': //จัดการลูกค้าหน้าสาขา
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'reportshippop': //รายงาน ระบบ POP SHIPPOP
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'reportcod': // รายงาน COD
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'reportbrance': // ยอดค้างชำระแต่ละสาขา
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        case 'createbill': // เก็บเงินปลายทาง
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_ENGINEER,
                vm.$ROLE.SHIPPOP_ACCOUNTING
            ])
            break;
        case 'transferStatement': // เก็บเงินปลายทาง
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_ENGINEER,
                vm.$ROLE.SHIPPOP_ACCOUNTING
            ])
            break;
        case 'reportdropoff': // รายงาน Drop-off
            status = checkRolesAuth0(Object.values(getRoleAuth0))
            break;
        default:
            status = true;
            break;
    }
    
    return status;
}

export const auth0RoleUsage = (usage = '') => {
    let status = true;

    switch ( String(usage) ) {
        case 'ratemanagement': // ปุ่มนำไปใช้ หน้าจัดการขนส่ง
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                vm.$ROLE.SHIPPOP_SALES,
            ])
            break;
        case 'interRatemanagement': // ปุ่มนำไปใช้ หน้าจัดการขนส่ง
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                vm.$ROLE.SHIPPOP_SALES,
            ])
            break;
        case 'transportedit': // ปุ่มแก้ไข หน้าแก้ไขข้อมูลขนส่ง
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                vm.$ROLE.SHIPPOP_SALES,
            ])
            break;
        case 'transportinteredit': 
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                vm.$ROLE.SHIPPOP_SALES,
            ])
            break;
        case 'transportdelete': // ปุ่มลบ หน้าจัดการขนส่ง
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
            ])
            break;
        case 'usersmanagecreate':
        case 'usersmanageedit': 
        case 'usersmanagedelete': // ปุ่มเพิ่ม แก้ไข ลบ หน้าจัดการสมาชิก SHIPPOP
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
            ])
            break;
        case 'agentmanagecreate': // ปุ่มเพิ่ม หน้าจัดการตัวแทนจำหน่าย (Superadmin)
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_SALES
            ])
            break;
        case 'agentmanageedit': // ปุ่มแก้ไข หน้าแก้ไขตัวแทนจำหน่าย (Superadmin)
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_SALES,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                vm.$ROLE.SHIPPOP_ACCOUNTING,
            ])
            break;
        case 'agentmanagedelete': // ปุ่มลบ หน้าจัดการตัวแทนจำหน่าย (Superadmin)
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_SALES,
            ])
            break;
        case 'brancemanagecreate': // ปุ่มเพิ่ม หน้าจัดการจัดการร้านค้า
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_SALES,
            ])
            break;
        case 'brancemanageedit': // ปุ่มแก้ไข หน้าจัดการจัดการร้านค้า
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                vm.$ROLE.SHIPPOP_SALES
            ])
            break;
        case 'brancemanagedelete': // ปุ่มลบ หน้าจัดการจัดการร้านค้า
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_SALES,
            ])
            break;
        case 'memberedit': // หน้าแก้ไขข้อมูลลูกค้า COD
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_SALES,
                vm.$ROLE.SHIPPOP_CUSTOMER_SERVICE,
                vm.$ROLE.SHIPPOP_MARKETING,
                vm.$ROLE.SHIPPOP_ACCOUNTING
            ])
            break;
        case 'commissionedit': // หน้าแก้ไขข้อมูลยืนยันตัวตน Commission
            status = checkRolesAuth0([
                vm.$ROLE.SHIPPOP_ADMINISTRATOR,
                vm.$ROLE.SHIPPOP_HEAD,
                vm.$ROLE.SHIPPOP_SENIOR,
                vm.$ROLE.SHIPPOP_SALES,
                vm.$ROLE.SHIPPOP_BUSINESS_DEVELOPMENT,
                vm.$ROLE.SHIPPOP_ACCOUNTING,
            ])
            break;
        default:
            status = true;
            break;
    }
    
    return status
}